import styled from 'styled-components';
import { colors } from 'Constants/Colors';

const ContainerBasicInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  font-family: metropolis;
  font-weight: bold;
  font-size: 1.25rem;
`;

const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 45%;
  height: 30vh;
  background: ${colors.WHITE};
  border-radius: 1rem;
  padding: 1rem;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ContainerIncludes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 45%;
  height: 30vh;
  background: ${colors.WHITE};
  border-radius: 1rem;
  padding: 1rem;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const descriptionText = {
  fontSize: '0.8rem',
  color: colors.GRAY_DARK,
};

const trainingText = {
  fontSize: '1rem',
  color: colors.GRAY_DARK,
  margin: '0.4rem 0',
};

const trainingList = {
  margin: '0',
  padding: '0 1rem',
};

export default {
  ContainerBasicInfo,
  ContainerDescription,
  ContainerIncludes,
  descriptionText,
  trainingText,
  trainingList,
};
